import React from 'react';
import CalendarIcon from 'hudl-react-kickoff/icons/Calendar';

const UniformUiComponents = window.__uniformui_Components;

const PublicNoEventsMessage = (props) => {
  const season = props.allSeasons.find(s => s.isSelected);
  const seasonName = `${season.year}-${season.year + 1} Season`;
  return (
    <div className="tab-blank-state">
      <h1>{props.teamName} has no {props.isTraining ? 'training ' : 'events '}
        scheduled for the {seasonName}.</h1>
      <CalendarIcon className="calendar-icon blank-icon"/>
      <p>
        Check back later. Until then why don't you find out who's on the Team.
      </p>
      <br/>
      <UniformUiComponents.Button
        onClick={(e) => {
          e.preventDefault();
          props.onChangeTab('team');
        }}
        size="small"
        type="primary"
        text="Check Out The Team"
      />
    </div>
  );
};

PublicNoEventsMessage.propTypes = {
  teamId: React.PropTypes.string.isRequired,
  teamName: React.PropTypes.string.isRequired,
  schoolName: React.PropTypes.string.isRequired,
  allSeasons: React.PropTypes.arrayOf(React.PropTypes.shape({
    id: React.PropTypes.string.isRequired,
    hasDetails: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    year: React.PropTypes.number.isRequired,
    events: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  })),
  isTraining: React.PropTypes.bool,
  onChangeTab: React.PropTypes.func.isRequired,
};

export default PublicNoEventsMessage;
